/* Global Offices Section JavaScript */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    function updateTimes() {
      const timeElements = document.querySelectorAll('.office-card__time[data-timezone]');
      if (!timeElements.length) return;

      const locale = document.documentElement.lang || 'en-US';

      timeElements.forEach((el) => {
        const timezone = el.getAttribute('data-timezone');
        if (!timezone) return;

        try {
          const now = new Date();
          const timeString = now.toLocaleTimeString(locale, {
            timeZone: timezone,
            hour: '2-digit',
            minute: '2-digit',
            hour12: true, // Optional: could be dynamic based on locale preference
          });

          // Check if we have a localized "Local Time" suffix or just show time
          // For now, we keep the time string clean.
          // The suffix (Local Time) was hardcoded in JS previously.
          // We can remove it or let liquid handle it if needed.
          // The previous code had: `${timeString} (Local Time)`
          // We will stick to the time only, or simpler logic.
          // Actually, let's keep it simple: Just the time.
          el.textContent = timeString;
          el.classList.add('is-loaded');
        } catch (e) {
          // Silent fail for invalid timezones
          // console.warn('Invalid timezone:', timezone); 
          el.textContent = '';
        }
      });
    }

    // Update immediately and then every minute
    updateTimes();
    setInterval(updateTimes, 60000);
  });
})();
